import { Component, Input } from '@angular/core';
import { Article } from '../../../core/models';

@Component({
  selector: 'app-featured-list-week',
  templateUrl: './featured-list-week.component.html',
  styleUrls: ['./featured-list-week.component.scss'],
})
export class FeaturedListWeekComponent {
  @Input() articles: Article[];
  constructor() {}

  getArticleImage(article: Article) {
    return (
      article.visual ?? '/assets/media/static/article_pic_placeholder.webp'
    );
  }

  protected readonly encodeURIComponent = encodeURIComponent;
}
